import React, { useState, useEffect, useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import styled from "styled-components";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import previewImg from "../../assets/icons/preview.png";
import publishImg from "../../assets/icons/publish.png";
import unpublishImg from "../../assets/icons/unpublish.png";

import PeopleIcon from "@mui/icons-material/People";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";

import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import {
  GET_ALL_TERMS_QUERY,
  NO_OF_APPLICANTS_QUERY,
  DELETE_TERM_MUTATION,
  CHANGE_ACTIVATE_STATUS_MUTATION,
} from "../../graphQL/term_qry";
import { GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY } from "../../graphQL/component_qry";

import { project_url } from "../../constants/Data";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    height: "870px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function VolunteerList() {
  const [rows, setRows] = useState([]);
  const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);
  const [previewAlertMsg, setPreviewAlertMsg] = useState([]);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const classes = useStyles();
  let clientId = 1;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const [fetchAllTerms] = useManualQuery(GET_ALL_TERMS_QUERY);
  const [fetchNoOfApplicants] = useManualQuery(NO_OF_APPLICANTS_QUERY);
  const [fetchFormComponentsAnswers] = useManualQuery(
    GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  const [alertActivateMsg, setAlertActivateMsg] = useState([]);

  function confirmActivateStatus(row, urlActivated) {
    if (urlActivated)
      setAlertActivateMsg({
        title: "Activate Term",
        type: "publishConfirmation",
        msg:
          "You are about to activate the term “" +
          row.name +
          "”. Do you wish to proceed?",
        termId: row.id,
        urlActivated: urlActivated,
      });
    else {
      setAlertActivateMsg({
        title: "Deactivate Term",
        type: "publishConfirmation",
        msg:
          "You are about to deactivate the term “" +
          row.name +
          "”. Do you wish to proceed?",
        termId: row.id,
        urlActivated: urlActivated,
      });
    }
  }
  const [changeActivateStatus] = useMutation(CHANGE_ACTIVATE_STATUS_MUTATION, {
    fetchPolicy: "network-only",
  });
  const updateActivateStatus = async (termId, urlActivated) => {
    const {
      loading: loadingActivateStatus,
      error: errorActivateStatus,
      data: dataActivateStatus,
    } = await changeActivateStatus({
      variables: {
        termId: parseInt(termId),
        urlActivated: urlActivated,
      },
    });
    if (
      !loadingActivateStatus &&
      dataActivateStatus &&
      dataActivateStatus.changeActivateStatus
    ) {
      getTermsList();
    }
    if (errorActivateStatus) {
      if (errorActivateStatus.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
      //else
      //  setAlertMsg({
      //    title: "Unpublish Form",
      //    msg: errorActivateStatus.graphQLErrors[0].message,
      //  });
    }
  };

  const [deleteTermMutation] = useMutation(DELETE_TERM_MUTATION, {
    fetchPolicy: "network-only",
  });

  const getTermsList = async () => {
    const {
      loading: termsListLoading,
      error: termsListError,
      data: termsListData,
    } = await fetchAllTerms({
      variables: {
        clientId: parseInt(clientId),
      },
    });
    if (!termsListLoading && termsListData && termsListData.allTerms) {
      let tmp = [];
      for (var i in termsListData.allTerms) {
        let currTerm = termsListData.allTerms[i];
        let data = {};

        data["id"] = currTerm.termId;
        data["termUuid"] = currTerm.termUuid;
        data["name"] = currTerm.name;
        data["startDate"] = dayFormat(currTerm.startDate);
        data["endDate"] = dayFormat(currTerm.endDate);
        data["noOfSeats"] = currTerm.noOfSeats;
        data["formName"] = currTerm.formId.name;
        data["formUuid"] = currTerm.formId.formUuid;
        data["status"] = currTerm.urlActivated === true ? "Active" : "Inactive";
        data["publicFormURLVal"] = currTerm.urlActivated;

        const {
          loading: noOfApplicantsLoading,
          error: noOfApplicantsError,
          data: noOfApplicantsData,
        } = await fetchNoOfApplicants({
          variables: {
            termId: parseInt(currTerm.termId),
          },
        });
        if (!noOfApplicantsLoading && noOfApplicantsData) {
          data["noOfApplicants"] = noOfApplicantsData.noOfTermApplicants;
        }

        tmp.push(data);
      }
      setRows(tmp);
      setLoadData(true);
    }
  };

  const previewForm = async formUuid => {
    if (formUuid) {
      const {
        loading: formComponentsAnswersLoading,
        error: formComponentsAnswersError,
        data: formComponentsAnswersData,
      } = await fetchFormComponentsAnswers({
        variables: { formUuid: formUuid },
      });

      if (
        !formComponentsAnswersLoading &&
        formComponentsAnswersData &&
        formComponentsAnswersData.formComponentAnswerList
      ) {
        if (
          formComponentsAnswersData.formComponentAnswerList.componentList.length !== 0
        ) {
          window.open(`${project_url}/forms/${formUuid}/preview`);
        } else {
          setPreviewAlertMsg({
            title: "Preview Form",
            msg: "This form has no object. Nothing to preview.",
          });
        }
      }
      if (
        formComponentsAnswersError &&
        formComponentsAnswersError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTermsList())();
  }, []);

  function checkDeleteStatus(row) {
    if (row.status === "Active" && row.noOfApplicants > 0)
      setAlertDeleteMsg({
        title: "Delete Term",
        msg: "You cannot delete this term, because at least one applicant has filled out its form.",
      });
    else
      setAlertDeleteMsg({
        title: "Delete Term",
        type: "deleteConfirmation",
        msg: "Are you sure you want to delete the term “" + row.name + "”?",
        termId: row.id,
      });
  }

  const deleteTerm = async termId => {
    console.log("rows 111: ", rows);
    const {
      loading: loadingTermDelete,
      error: errorTermDelete,
      data: dataTermDelete,
    } = await deleteTermMutation({
      variables: {
        termId: parseInt(termId),
      },
    });
    if (!loadingTermDelete && dataTermDelete && dataTermDelete.deleteTerm) {
      setRows(rows.filter(term => parseInt(term.id) !== parseInt(termId)));
    }
    if (errorTermDelete) {
      if (errorTermDelete.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
      else alert(errorTermDelete.graphQLErrors[0].message);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 170,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "noOfSeats",
      headerName: "No of Seats",
      minWidth: 80,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "noOfApplicants",
      headerName: "No of Applicants",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "formName",
      headerName: "Form Name",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return !rows.row.publicFormURLVal ? (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {rows.row.formName}
            <StyledTooltip title="Preview form">
              <img
                style={{ marginLeft: 5, cursor: "pointer" }}
                src={previewImg}
                onClick={() => previewForm(rows.row.formUuid)}
              />
            </StyledTooltip>
          </Box>
        ) : (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "left",
            }}
          >
            {rows.row.formName}
          </Box>
        );
      },
    },
    {
      field: "status",
      headerName: "Term Status",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "publicFormURL",
      headerName: "Public Form Page",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var path = `${project_url}/terms/` + rows.row.termUuid + "/application-form";
        return rows.row.publicFormURLVal ? (
          <Button
            variant="contained"
            size="small"
            className={classes.buttonStyle}
            onClick={() => window.open(path)}
          >
            View
          </Button>
        ) : (
          ""
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editPath = `${project_url}/terms/` + rows.row.termUuid ;
        var applicantsPath = `${project_url}/terms/` + rows.row.termUuid + "/applicants";
        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <>
              {rows.row.status === "Active" ? (
                <StyledTooltip interactive title="Deactivate this term">
                  <LockOpenOutlinedIcon
                    color="action"
                    style={{
                      paddingRight: 15,
                      paddingTop: 6,
                      cursor: "pointer",
                      fontSize: 24,
                    }}
                    onClick={() => confirmActivateStatus(rows.row, false)}
                  />
                </StyledTooltip>
              ) : (
                <StyledTooltip interactive title="Activate this term">
                  <LockOutlinedIcon
                    color="action"
                    style={{
                      paddingRight: 15,
                      paddingTop: 6,
                      cursor: "pointer",
                      fontSize: 24,
                    }}
                    onClick={() => confirmActivateStatus(rows.row, true)}
                  />
                </StyledTooltip>
              )}
            </>
            <StyledTooltip interactive title="List of applicants">
              <PeopleIcon
                color="action"
                style={{
                  paddingRight: 15,
                  paddingTop: 4,
                  cursor: "pointer",
                  fontSize: 30,
                }}
                onClick={() => navigate(applicantsPath)}
              />
            </StyledTooltip>
            <StyledTooltip title="Edit this term">
              <img
                style={{
                  paddingRight: 15,
                  cursor: "pointer",
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                }}
                src={penImg}
                onClick={() => navigate(editPath)}
              />
            </StyledTooltip>
            <StyledTooltip title="Delete this term">
              <img
                style={{
                  paddingRight: 15,
                  cursor: "pointer",
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                }}
                src={trashImg}
                onClick={() => checkDeleteStatus(rows.row)}
              />
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Terms
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              onClick={() => navigate(`${project_url}/terms/add`)}
            >
              Add
            </Button>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  if (loadContent && loadData)
    return (
      <div className={classes.root}>
        <Header />
        <div className={classes.container}>
          <Typography variant="h1">To be developped</Typography>
        </div>
      </div>
    );
  else return;
}

export default VolunteerList;
